/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import { Turbo } from '@hotwired/turbo-rails';
import './controllers';
// Bootstrap JS only (CSS comes from rails-assets-bootstrap gem)
import * as bootstrap from 'bootstrap';
// BS5 の data-API を確定的に配線する(tree-shaking で失われる副作用の代替)。
// jQuery 撤去 (#2428) で data-bs-toggle/dismiss が沈黙した回帰への対処。
import './bootstrap_data_api';

// react-rails: mount React components rendered via the `react_component` helper.
// Component names resolve relative to app/javascript/components.
const componentRequireContext = require.context('./components', true);
const ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);

// react_ujs only auto-mounts on the `DOMContentLoaded` event (native mode, since
// we use Turbo rather than Turbolinks). This bundle is loaded as a deferred ES
// module, so it executes *after* DOMContentLoaded has already fired and the
// auto-mount handler never runs. Mount immediately if the DOM is already ready,
// and re-mount on Turbo navigations.
const mountReactComponents = () => ReactRailsUJS.mountComponents();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountReactComponents);
} else {
  mountReactComponents();
}
document.addEventListener('turbo:load', mountReactComponents);

// Maintain a window-level counter of in-flight axios requests so RSpec system
// specs can poll `window.axiosPendingRequests` from `wait_for_ajax` and reliably
// wait for XHR completion (Capybara's default polling has no XHR awareness).
const axios = require('axios');
window.axiosPendingRequests = 0;
axios.interceptors.request.use((config) => {
  window.axiosPendingRequests = (window.axiosPendingRequests || 0) + 1;
  return config;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return response;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});

Turbo.session.drive = false;
window.Turbo = Turbo;
// Expose Bootstrap globally so RSpec system specs can poll
// `window.bootstrap` to know that the BS5 ESM bundle has finished
// executing and `data-bs-toggle="modal"` click handlers are ready.
// Without this signal, Capybara can click a modal-trigger before
// Bootstrap binds, and the click is silently dropped.
window.bootstrap = bootstrap;
